import { useCallback, useEffect } from "react";
import { useLocalStorageVariable } from "2g-hooks";
import { useDataLoader } from "2g-hooks/fetch/";
import { DATA } from "b2b/api/paths";

export default function useKonfiguracniParametry() {
  const [state = {}, setState] = useLocalStorageVariable(
    "konfiguracniParametry.state"
  );

  const loader = useDataLoader({
    url: DATA.konfigParametry(),
    method: "get"
  });

  // useEffect(() => {
  //   !state.loaded && loader.load();
  // }, []);

  useEffect(() => {
    if (loader.loaded) {
      setState({
        data: loader.data,
        error: loader.error,
        loaded: loader.loaded
      });
    }
  }, [loader.data, loader.error, loader.loaded]);

  const getByKod = useCallback(
    kod => {
      const data = state.data || [];
      return data.find(param => param.kod.name == kod);
    },
    [state.data]
  );

  const getHodnotaByKod = useCallback(
    kod => getByKod(kod)?.hodnotaCs,
    [getByKod]
  );

  return {
    ...state,
    getByKod,
    getHodnotaByKod,
    loading: loader.loading,
    loader,
    reload: loader.reload
  };
}
